module.exports = __webpack_public_path__ + "img/news2-2.e4b0cd2f.png";